export type MinimalUser = {
  fullName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
};

export function formatDisplayName(user?: MinimalUser | null): string {
  if (!user) return '';
  const full = (user.fullName || '').trim();
  if (full.length > 0) return full;
  const composed = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
  return composed || (user.email || '') || '';
}


